// File: typescript/apps/front-end/src/main/react/group/SetFlairDialogLazy.ts
//
// Lazy delegate for the set-flair dialog (round 7 slice 2b). `UserButtons` is on the eager graph, so the dialog
// loads on demand the first time a leader opens it (rule 26, the `GroupBanUserDialogLazy` precedent).

import type { SetFlairDialogProps } from "@/main/react/group/SetFlairDialog";
import { importChunkWithRetryAndReload } from "@/lib/lazyWithRetry";

export function showSetFlairDialog(props: Omit<SetFlairDialogProps, "onClose">) {
    void importChunkWithRetryAndReload(
        () => import("@/main/react/group/SetFlairDialog").then((m) => ({ default: m.showSetFlairDialog })),
        "group-set-flair-dialog",
    ).then((m) => m.default(props));
}
